import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=0f53fc02&scoped=true&"
import script from "./PieChartCard.vue?vue&type=script&lang=ts&"
export * from "./PieChartCard.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartCard.vue?vue&type=style&index=0&id=0f53fc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53fc02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VRow})
